export default __webpack_public_path__ + "static/rigorlogo-bad6f1ff2d1c0203e0c901c8ae0e97c7.png";